import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, empty, of, Observable } from 'rxjs';
import { tap, take, catchError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { LogFilesService } from '../../services/log-files.service';

@Component({
  selector: 'mojo-support-page',
  templateUrl: './support-page.component.html'
})
export class SupportPageComponent implements OnInit {


  title = 'Support - Mojo';

  enabledSubject = new BehaviorSubject<boolean>(true);
  get enabled() {
    return this.enabledSubject.asObservable();
  }

  constructor(
    private readonly logService: LogFilesService,
    private readonly messageService: ToastrService
    ) {


  }

  download() {
    this.enabledSubject.next(false);
    this.logService.getLogsZip().pipe(
      take(1),
      tap(() => this.messageService.success('File Downloaded successfully', 'Log File Download')),
      catchError(err => {
        this.messageService.error('Could not download log file zip', 'Download Error');
        this.enabledSubject.next(true);
        return empty();
      })
    ).subscribe(() => this.enabledSubject.next(true));
  }

  ngOnInit() {
  }


}
